module.exports = new __parcel__URL__("jpd-portfolio-management-communicate-progress.cf4ff262.svg").toString();